package com.milta.feature.settings.presentation

/**
 * State for the Admin dashboard's "Paramètres" screen (2026-10-05) — a trimmed-down sibling of
 * [WebSettingsState]: an Admin account has no Organisation/Subscription (see [Screen.AdminDashboard]'s
 * doc in webApp's Main.kt), so only the account-level interface language applies here.
 */
data class AdminSettingsState(
    val isLoading: Boolean = false,
    val language: String? = null,
    val isLanguageSaving: Boolean = false,
    /** "server_error" | "offline" */
    val languageError: String? = null,
)
